import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import media from "cssMix/index"
import { useDebouncedCallback } from "use-debounce"
import { FiChevronUp } from "react-icons/fi"
import { ContextStore } from "Reducer"

const showIcon = (setShow) => {
  const ref = document.getElementById("root")
  const top = ref.scrollTop
  if (top > 50) setShow(true)
  else if (top === 0) setShow(false)
}

export default () => {
  const [isShow, setIsShow] = useState(false)

  const [debounceSetState] = useDebouncedCallback(
    () => showIcon(setIsShow),
    100
  )

  const {
    state: { stateReducer },
  } = useContext(ContextStore)

  const gameUrl = stateReducer.get("gameUrl")

  useEffect(() => {
    const refListner = document
      .getElementById("root")
      .addEventListener("scroll", debounceSetState)
    return document
      .getElementById("root")
      .removeEventListener("scroll", refListner)
  }, [debounceSetState])

  useEffect(() => {
    if (gameUrl) setIsShow(false)
    else showIcon(setIsShow)
  }, [gameUrl])

  const goToTop = () => {
    document.getElementById("root").scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    })
  }
  return (
    isShow && (
      <StyledGoTop key="gotop" onClick={goToTop} className="gav2_btn_gotop">
        <FiChevronUp />
      </StyledGoTop>
    )
  )
}

const StyledGoTop = styled.div`
  position: fixed;
  right: 0;
  bottom: 70px;
  z-index: 50;
  width: 60px;
  height: 60px;
  -webkit-tap-highlight-color: transparent;
  background-size: 100%;
  transform: translateZ(0);
  background: #f9be00;
  border-radius: 6px 0 0 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    height: 40px;
    width: 40px;
    color: #141620;
  }
  ${media.tablet`
      width:50px;
    height:50px;
  bottom:30px;
>svg{
    height:30px;
    width:30px; 
  }
    `}
  ${media.tablet`
      width:40px;
    height:40px;
  bottom:10%;
>svg{
    height:30px;
    width:30px; 
  }
    `}
`
